var map = {
	"./bronzeShadow.webp": "./src/pages/chicken-road/assets/bronzeShadow.webp",
	"./bronzeShadowMob.webp": "./src/pages/chicken-road/assets/bronzeShadowMob.webp",
	"./goldShadow.webp": "./src/pages/chicken-road/assets/goldShadow.webp",
	"./goldShadowMob.webp": "./src/pages/chicken-road/assets/goldShadowMob.webp",
	"./silverShadow.webp": "./src/pages/chicken-road/assets/silverShadow.webp",
	"./silverShadowMob (1).webp": "./src/pages/chicken-road/assets/silverShadowMob (1).webp",
	"./silverShadowMob.webp": "./src/pages/chicken-road/assets/silverShadowMob.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/pages/chicken-road/assets sync recursive ^\\.\\/.*Shadow.*\\.webp$";